import { ToastContainer, ToastContainerProps } from 'react-toastify';
import { RIBBON_TOAST_AUTO_CLOSE_MS, RIBBON_TOAST_STYLE } from './ribbon-toast';

type NotificationsContainerProps = Partial<ToastContainerProps>;

/**
 * Renders the shared toast container. Individual toasts supply the Paper ribbon chrome via
 * {@link showRibbonToast}; the Toastify shell stays transparent.
 */
export function NotificationsContainer(props: NotificationsContainerProps) {
  return (
    <ToastContainer
      closeButton={false}
      icon={false}
      hideProgressBar
      style={{
        minHeight: '3rem',
        width: '360px',
      }}
      toastStyle={RIBBON_TOAST_STYLE}
      key="toast-container"
      autoClose={RIBBON_TOAST_AUTO_CLOSE_MS}
      position="bottom-right"
      theme="light"
      {...props}
    />
  );
}
